import BidItemChangeForm, { createEmptyBidItemChangePoint } from "components/bid/bidItemChanges/form";
import InlineBtn from "components/shared/inlineBtn";
import React from "react";

const PlannedItemChangePoints = ({
    addModal,
    bid,
    bidId,
    bidLastCarLocation,
    deletedItems = [],
    deletedItemsName,
    firstBidPointEntered,
    hasParallelBidId,
    items = [],
    itemsName,
    itemChangesHistory,
    onChange,
    organization,
    route,
    switchMap,
}) => {
    const changeItems = (nextItems) => {
        onChange({ name: itemsName, value: nextItems });
    };

    const setItem = (nextItem, changeIndex) => {
        changeItems(items.map((item, index) => (index === changeIndex ? nextItem : item)));
    };

    const startAddPoint = () => {
        changeItems([...items, createEmptyBidItemChangePoint()]);
    };

    const deletePoint = (index) => {
        const item = items[index];
        const nextItems = items.filter((_item, itemIndex) => itemIndex !== index);
        changeItems(nextItems);

        if (item?.id) {
            const alreadyDeleted = deletedItems.some((deletedItem) => deletedItem.id === item.id);
            if (!alreadyDeleted) {
                onChange({
                    name: deletedItemsName,
                    value: [...deletedItems, { id: item.id }],
                });
            }
        }
    };

    const renderItem = (item, index) => (
        <div key={item.id || item.keyExtension || index}>
            <div className="book-form__section-head book-form__section-head--closable book-form__section-head--item-change-point">
                <div
                    className="book-form__section-close close book-form__section-close--point"
                    onClick={() => deletePoint(index)}
                    title="Удалить точку"
                />
                <div className="form-group">
                    <strong>Точка перецепки {index + 1}</strong>
                </div>
            </div>
            <BidItemChangeForm
                add={addModal}
                bid={bid}
                bidId={bidId}
                bidLastCarLocation={bidLastCarLocation}
                firstBidPointEntered={firstBidPointEntered}
                hasParallelBidId={hasParallelBidId}
                itemChangesHistory={itemChangesHistory}
                item={item}
                mode="draft"
                onDraftChange={(nextItem) => setItem(nextItem, index)}
                organization={organization}
                route={route}
                switchMap={switchMap}
            />
        </div>
    );

    return (
        <div>
            <div className="form-group">
                <strong>Точки перецепки</strong>
            </div>
            {items.length > 0 ? (
                items.map(renderItem)
            ) : (
                <div className="text-muted small mb-3">Точки перецепки не добавлены</div>
            )}
            <div className="book-form__buttons">
                <InlineBtn value="Точка перецепки" cname="plus" action={startAddPoint} />
            </div>
        </div>
    );
};

export default PlannedItemChangePoints;
